import { render, staticRenderFns } from "./GenericControlsEditForm.vue?vue&type=template&id=62e77275&"
import script from "./GenericControlsEditForm.vue?vue&type=script&lang=js&"
export * from "./GenericControlsEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports